/**
 * 当前插件仅在登录引擎组件中使用
 */
import $ from "jquery"
import Qs from "qs"
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions, hasProperty } from "utils"
import { image_children } from "materials/image/menus/index.js"
import { input_children } from "materials/input/menus/index.js"
class loginEngineComponentClass {
  constructor(val) {
    this.content = val
    this.getElement = ""
    this.getElement1 = ""
    this.getElement2 = ""
    this.getElement3 = ""
  }
  async init() {
    const that = this
    const cxTabs = this.getElementInLayout(0)?.loginTitleOptions?.find(item => item.type === "classification")
    if (cxTabs) {
      const tabsList = cxTabs.options?.tabsList
      console.log("tabsList :>>", tabsList)
      this.content.$changeOptionsEV(tabsList, "tabsList", false, null, this.content.myid, true)
    }
    let tabsList = this.getElementInLayout(0)?.loginOptions?.tabsList
    let index1 = 0
    let index2 = 1
    let index3 = 2
    let index4 = 3
    if (tabsList && tabsList.length > 0) {
      index1 = tabsList.findIndex(item=>item.loginWay === 1)
      index2 = tabsList.findIndex(item=>item.loginWay === 2)
      index3 = tabsList.findIndex(item=>item.loginWay === 3)
      index4 = tabsList.findIndex(item=>item.loginWay === 4)
    }
    this.phoneIndex = index1 !== -1 ? index1 : 0
    this.codeIndex = index2 !== -1 ? index2 : 1
    this.schoolIndex = index3 !== -1 ? index3 : 2
    this.messageIndex = index4 !== -1 ? index4 : 3
    this.getElement = this.getElementInLayout(this.phoneIndex)
    this.getElement1 = this.getElementInLayout(this.codeIndex)
    this.getElement2 = this.getElementInLayout(this.schoolIndex)
    this.getElement3 = this.getElementInLayout(this.messageIndex)
    // console.log('getElement :>>',this.getElement);
    // console.log('this.content :>>',that.content);
    this.height = that.getElement.loginOptions.height
    // 手机号登录
    // this.phoneLogin = that.getElement.loginOptions.phoneLogin
    // if (!this.phoneLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(1)").hide()
    // }
    // 扫码登录
    // this.codeLogin = that.getElement.loginOptions.codeLogin
    // if (!this.codeLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(2)").hide()
    // }
    // 短信验证码登录
    // this.testLogin = that.getElement.loginOptions.testLogin
    // if (!this.testLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(4)").hide()
    // }
    // 机构账户登录
    // this.schoolLogin = that.getElement.loginOptions.schoolLogin
    // if (!this.schoolLogin) {
    //   $(that.content.$el).find(".tabsContainer .tab:nth-child(3)").hide()
    // }
    // 只有一个时隐藏tab
    // let checkBoxList = [this.phoneLogin, this.codeLogin, this.testLogin, this.schoolLogin]
    // let count = checkBoxList.filter(item => item == true)
    // if (count.length > 1) {
    //   $(that.content.$el).find(".tabsContainer").show()
    // } else {
    //   $(that.content.$el).find(".tabsContainer").hide()
    // }
    // 登录方式
    this.loginWay = that.getElement.loginOptions.loginWay || "1"
    if (this.loginWay == "1") {
      // $(that.content.$el).find(".top>div:first-child").show()
      // $(that.content.$el).find(".row").hide()
      // $(that.content.$el)
      //   .find(`.row:nth-child(${that.getElement.loginOptions.activeIndex + 1})`)
      //   .show()
      // that.placeholder = "手机号"
    } else {
      // $(that.content.$el).find(".top>div:first-child").hide()
      // $(that.content.$el).find(".row").hide()
      // $(that.content.$el).find(`.row:nth-child(1)`).show()
      // that.placeholder = "账号"
    }
    that.tipsShowHide()
    setTimeout(() => {
      that.initState()
      // that.telPhoneLogin()
      // that.codeLoginFun()
      // that.schoolIdLogin()
      // that.messageLogin()
      // 修改提示文案
      // $(
      //   `.container_id_${that.getElement.loginMsg.container_id}-rect_id_${that.getElement.loginMsg.rect_id}-uid_${that.getElement.loginUid}-elementInLayoutId_${that.getElement.loginElementInLayout[0].elementInLayoutId} .input-component input`
      // ).attr("placeholder", that.placeholder)
      that.tabClick()
    }, 1000)
  }
  findElementIndex(element, type) {
    return element ? element.findIndex(item => item.loginType === type) : -1
  }
  changeOptions(value, name, getElement, index) {
    if (index != -1) {
      this.content.$changeOptionsEV(value, name, false, null,{
        uid: getElement.loginUid,
        elementInLayoutId: getElement.loginElementInLayout[index].elementInLayoutId,
        ...getElement.loginMsg
      })
    }
  }
  // 获取登录基本组件
  getElementInLayout(index) {
    const loginMsg = {
      container_id: this.content.myid.container_id,
      rect_id: this.content.myid.rect_id,
      elementInAutoLayoutId: this.content.myid.elementInAutoLayoutId,
      path: this.content.myid.path
    }
    const rectAttr = this.content.getRectAttribute.call(this.content, loginMsg)
    const loginOptions = [this.content.options.rows[index]]
    const loginUid = getAllColsUidInLayoutComponent(loginOptions)[0]
    const loginElementInLayout = handleFindLayoutComponentOptions(loginOptions, loginUid)
    const loginTitleOptions = this.content.options.titleOptions[0].elementOptions
    return {
      loginOptions: this.content.options,
      loginMsg: loginMsg,
      loginUid: loginUid,
      loginElementInLayout: loginElementInLayout,
      loginTitleOptions: loginTitleOptions
    }
  }
  // 初始状态
  initState() {
    const that = this
    // 是否开启双因素安全验证
    const doubleFactor = hasProperty(that.getElement.loginOptions, "doubleFactor")
      ? hasProperty(that.getElement.loginOptions, "doubleFactor")
      : false
    // 是否开启独立密码验证
    const alonePassword = hasProperty(that.getElement.loginOptions, "alonePassword")
      ? hasProperty(that.getElement.loginOptions, "alonePassword")
      : false
  }
  // 隐藏显示错误提示
  tipsShowHide() {
    const that = this
    let tipsIdx1 = this.findElementIndex(this.getElement.loginElementInLayout, "loginError")
    let tipsIdx2 = this.findElementIndex(this.getElement2.loginElementInLayout, "loginError")
    let tipsIdx3 = this.findElementIndex(this.getElement3.loginElementInLayout, "loginError")    
    // 隐藏错误提示
    this.changeOptions(0, "opacity", this.getElement, tipsIdx1)
    this.changeOptions(0, "opacity", this.getElement2, tipsIdx2)
    this.changeOptions(0, "opacity", this.getElement3, tipsIdx3)
    // 登录状态
    const loginStatus = that.getElement.loginOptions.loginStatus || "1"
    if (loginStatus == "2") {
      this.changeOptions(100, "opacity", this.getElement, tipsIdx1)
      this.changeOptions(100, "opacity", this.getElement2, tipsIdx2)
      this.changeOptions(100, "opacity", this.getElement3, tipsIdx3)
    }
    let downIdx = this.findElementIndex(this.getElement3.loginElementInLayout, "loginCountDown")
    // 隐藏30s后重新获取
    this.changeOptions(0, "opacity", this.getElement3, downIdx) 
  }
  tabClick() {
    const that = this
    $(that.content.$el).find(".tabsContainer .tab").on("click", function () {
      // 用于处理点击tab后是否显示注册按钮出错问题
      setTimeout(() => {
        that.tipsShowHide()
        let tabsList =  that.getElement.loginOptions.tabsList
        let phoneIndex = tabsList.findIndex(item=>item.loginWay === 1)
        let codeIndex = tabsList.findIndex(item=>item.loginWay === 2)
        let schoolIndex = tabsList.findIndex(item=>item.loginWay === 3)
        let messageIndex = tabsList.findIndex(item=>item.loginWay === 4)
        phoneIndex !== this.phoneIndex ? that.getElement = that.getElementInLayout(phoneIndex) : ""
        codeIndex !== this.codeIndex ? that.getElement1 = that.getElementInLayout(codeIndex) : ""
        schoolIndex !== this.schoolIndex ? that.getElement2 = that.getElementInLayout(schoolIndex) : ""
        messageIndex !== this.messageIndex ? that.getElement3 = that.getElementInLayout(messageIndex) : ""
        let activeIndex = that.getElement.loginOptions.activeIndex
        console.log('activeIndex :>>',activeIndex);
        let index1 = that.findElementIndex(that.getElement.loginElementInLayout, "loginRegister")
        let index2 = that.findElementIndex(that.getElement2.loginElementInLayout, "loginRegister")
        let index3 = that.findElementIndex(that.getElement3.loginElementInLayout, "loginRegister")        
        let index4 = that.findElementIndex(that.getElement3.loginElementInLayout, "loginCountDown")
        let downBtn = index4 !== -1 ? $(`.container_id_${that.getElement3.loginMsg.container_id}-rect_id_${that.getElement3.loginMsg.rect_id}-uid_${that.getElement3.loginUid}-elementInLayoutId_${that.getElement3.loginElementInLayout[index4].elementInLayoutId}`) : ""        
        if (activeIndex == phoneIndex) { // 手机号登录
          that.registFun(that.getElement,index1)
          that.setImageComponent(that.getElement,phoneIndex)
        } else if(activeIndex == schoolIndex) { // 机构账户登录
          that.registFun(that.getElement2,index2)
          that.setImageComponent(that.getElement2,schoolIndex)
        } else if(activeIndex == messageIndex) { // 短信验证码登录
          that.registFun(that.getElement3,index3)
          // 隐藏验证码倒计时
          downBtn?.hide()
        }
      }, 100);
    })
  }
  registFun(getElement,index) {
    // 是否显示注册地址
    this.ifShowRegister = this.getElement.loginOptions.ifShowRegister
    // 是否显示注册按钮
    let registText = ""
    if(this.ifShowRegister) {
      registText = "新用户注册"
    }
    this.changeOptions(registText, "content", getElement, index)
  }
  // 是否显示验证码
  setImageComponent(getElement,index) {
    const {showImageCode, tabsList} = this.getElement.loginOptions
    if (tabsList[index].name === "手机号登录" || tabsList[index].name === "机构账号登录") {
      const inputIndex = this.findElementIndex(getElement.loginElementInLayout, "loginCodeInput")
      const imageIndex = this.findElementIndex(getElement.loginElementInLayout, "loginCodeImage")
      if (inputIndex === -1 && showImageCode) {
        const input = input_children[0]
        let options = JSON.parse(JSON.stringify(input.attribute.options))
        options.loginType = "loginCodeInput"
        options.width = 360
        options.height = 48
        options.placeholder = "请输入验证码"
        options.readonly = true
        options.borderWidth = 1
        options.borderColor = "#ECECF1"
        options.textPaddingTypeFlag = 2
        options.paddingLeft = 12
        let param = {
          ...this.content.myid,
          uid: getElement.loginUid,
          elementOptions: options
        } 
        this.content.$store.dispatch(this.content.request_prefix + "/addComponentInLayout", param)
      } else {
        this.changeOptions(showImageCode, "isShow", getElement, inputIndex)
      }
      if (imageIndex === -1 && showImageCode) {
          const input = image_children[0]
          let options = JSON.parse(JSON.stringify(input.attribute.options))
          options.loginType = "loginCodeImage"
          options.width = 66
          options.height = 33
          options.left = 296
          options.top = 16
          options.shapeType = "radius"
          options.clipSize = "100% 100%"
          options.imgSrc = "https://p.cldisk.com/star3/origin/ead2350633297ac5ca7b80168694f1ab.jpeg?rw=200&rh=42&_fileSize=3975&_orientation=1"
          let param = {
            ...this.content.myid,
            uid: getElement.loginUid,
            elementOptions: options
          }
          this.content.$store.dispatch(this.content.request_prefix + "/addComponentInLayout", param)
      } else {
        this.changeOptions(showImageCode, "isShow", getElement, imageIndex)
      }
    }
  }
}
export default {
  data() {
    return {
      loginEngineComponentData: new loginEngineComponentClass(this)
    }
  },
  methods: {
    async loginEngineComponentPlugin() {
      await this.loginEngineComponentData.init()

      // 更新当前componentTypeId的值
      let menu = this.request_prefix === "appStage" ? this.$store.state.appMenu.menu : this.$store.state.menu.menu
      let componentTypeId = ""
      if (menu.moduleTypes.length > 0) {
        componentTypeId = menu.moduleTypes.filter(item => item.name === "登录框")?.[0]?.publicId
      }
      this.$changeOptionsEV(componentTypeId, "componentTypeId", false, null, this.myid, true)
    }
  }
}
